import { render, staticRenderFns } from "./Calendar.vue?vue&type=template&id=7eb43d81&"
import script from "./Calendar.vue?vue&type=script&lang=js&"
export * from "./Calendar.vue?vue&type=script&lang=js&"
import style0 from "./Calendar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/carolinethuelarsen/Documents/development/ibg-screen-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7eb43d81')) {
      api.createRecord('7eb43d81', component.options)
    } else {
      api.reload('7eb43d81', component.options)
    }
    module.hot.accept("./Calendar.vue?vue&type=template&id=7eb43d81&", function () {
      api.rerender('7eb43d81', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/views/calendar/Calendar.vue"
export default component.exports